import { Moon, Sun, Monitor } from 'lucide-react'
import { useThemeStore } from '@/stores/themeStore'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export function ThemeToggle() {
  const { theme, setTheme } = useThemeStore()

  return (
    <div className="flex items-center gap-1 p-1 bg-secondary rounded-lg">
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          'h-8 w-8',
          theme === 'light' && 'bg-background shadow-sm'
        )}
        onClick={() => setTheme('light')}
        title="Light mode"
      >
        <Sun className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          'h-8 w-8',
          theme === 'dark' && 'bg-background shadow-sm'
        )}
        onClick={() => setTheme('dark')}
        title="Dark mode"
      >
        <Moon className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          'h-8 w-8',
          theme === 'system' && 'bg-background shadow-sm'
        )}
        onClick={() => setTheme('system')}
        title="System preference"
      >
        <Monitor className="h-4 w-4" />
      </Button>
    </div>
  )
}

// Simple toggle version (cycles through modes)
export function ThemeToggleSimple() {
  const { theme, setTheme } = useThemeStore()

  const cycleTheme = () => {
    if (theme === 'light') setTheme('dark')
    else if (theme === 'dark') setTheme('system')
    else setTheme('light')
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycleTheme}
      title={`Current: ${theme}. Click to change.`}
    >
      {theme === 'light' && <Sun className="h-5 w-5" />}
      {theme === 'dark' && <Moon className="h-5 w-5" />}
      {theme === 'system' && <Monitor className="h-5 w-5" />}
    </Button>
  )
}
